export const ROLES = {
  FREE: "ROLE_EXTENSION_FREE_USER",
  PREMIUM_M: "ROLE_EXTENSION_PREMIUM_MONTHLY",
  PREMIUM_Y: "ROLE_EXTENSION_PREMIUM_YEARLY",
};
